export default __webpack_public_path__ + "static/rings-540284e123c3e91b5cef4319b21bd6fc.jpg";